import React, { useCallback } from 'react';
import { HStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography';
import { useAccount } from 'wagmi';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { useCompliance } from '@/components/ComplianceProvider/ComplianceProvider';
import { useAddLiquidityModal } from '@/components/AddLiquidity/AddLiquidityModalProvider';
import { DEFAULT_MARGIN } from '@/constants/layout';

export function PoolsHeader() {
  const account = useAccount();
  const { isCompliant, openComplianceModals } = useCompliance();
  const { openAddLiquidityModal } = useAddLiquidityModal();

  const handleCreatePosition = useCallback(() => {
    if (!isCompliant) {
      openComplianceModals();
    } else {
      openAddLiquidityModal();
    }
  }, [isCompliant, openComplianceModals, openAddLiquidityModal]);

  return (
    <HStack justifyContent="space-between" alignItems="flex-start" gap={DEFAULT_MARGIN}>
      <HStack alignItems="center">
        <Text font="title1" as="h1">
          Pools
        </Text>
      </HStack>
      {account?.address && (
        <HStack alignItems="center">
          <Button compact onClick={handleCreatePosition} testID="create-position-button">
            Create position
          </Button>
        </HStack>
      )}
    </HStack>
  );
}
